import MainLayout from "@/components/layout/company/MainLayout.vue";
import TwspNameJson from "@/assets/json/township.json";
import RegionJson from "@/assets/json/region.json";
import { required, maxLength } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
// import $ from "jquery";
import axios from "axios";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "jobPostUpdate",
    
    components: {
        MainLayout,
        DatePicker,
        Loading
    },

    data() {
        return {
            isLoading: false,
            fullPage: true,
            isEditForm: true,
            submitted: false,
            isCategoryDropdownOpen: false,
            isRegionDropdownOpen: false,
            isTownshipDropdownOpen: false,
            isJobTypeDropdownOpen: false,
            job: {
                company_name: "",
                category_name: "",
                job_title: "",
                region: "",
                town: "",
                address: "",
                min_salary: "",
                max_salary: "",
                job_type: "",
                experience: "",
                qualification: "",
                description: "",
                short_desc: "",
                // latitude: "",
                // longitude: "",
                gender: "",
                expired_date: ""
            },
            company: [],
            category: [],
            jobType: [{
                    value: "1",
                    // name: "Full Time"
                    name: "Full-time"
                },
                {
                    value: "2",
                    // name: "Part Time"
                    name: "Part-time"
                },
                {
                    value: "3",
                    // name: "Internship"
                    name: "Internship"
                },
                {
                    value: "4",
                    // name: "Freelance"
                    name: "Freelance"
                },
                {
                    value: "5",
                    // name: "Work From Home"
                    name: "Remote Job"
                }
            ],
            regionArr: RegionJson,
            selectedTwspName: "",
            twspNameJson: TwspNameJson,
            twspName: []
        };
    },

    computed: {
        selectedCategoryName() {
            if (!this.category || !Array.isArray(this.category)) return '';
            const selected = this.category.find(cat => cat.id === this.job.category_id);
            return selected ? selected.category_name : '';
        },
        selectedRegionName() {
            if (this.job.region === '' || this.job.region === null || this.job.region === undefined) return '';
            return this.regionArr[this.job.region] || '';
        },
        selectedJobTypeName() {
            const selected = this.jobType.find(option => option.value === this.job.job_type);
            return selected ? selected.name : '';
        }
    },

    validations: {
        job: {
            company_name: {
                required
            },
            category_name: {
                required
            },
            job_title: {
                required,
                maxLength: maxLength(100)
            },
            // min_salary: {
            //     numeric
            // },
            // max_salary: {
            //     numeric
            // },
            job_type: {
                required
            },
            description: {
                required
            },
            short_desc: {
                required
            },
            expired_date: {
                required
            },
            gender: {
                required
            },
            region: {
                required
            },
            // town: {
            //     required
            // },
            address: {
                // required,
                maxLength: maxLength(100)
            }
        }
    },

    methods: {
        toggleCategoryDropdown() {
            this.isCategoryDropdownOpen = !this.isCategoryDropdownOpen;
            this.isRegionDropdownOpen = false;
            this.isTownshipDropdownOpen = false;
            this.isJobTypeDropdownOpen = false;
        },

        selectCategory(id, name) {
            this.job.category_id = id;
            this.job.category_name = name;
            this.isCategoryDropdownOpen = false;
        },

        toggleRegionDropdown() {
            this.isRegionDropdownOpen = !this.isRegionDropdownOpen;
            this.isCategoryDropdownOpen = false;
            this.isTownshipDropdownOpen = false;
            this.isJobTypeDropdownOpen = false;
        },

        selectRegion(id) {
            this.job.region = id;
            this.selectedTwspName = "";
            this.job.town = "";
            this.twspName = (id !== '' && id !== null && id !== undefined) ? this.changeTwspName(id) : [];
            this.isRegionDropdownOpen = false;
        },

        toggleTownshipDropdown() {
            if (this.job.region !== '' && this.job.region !== null && this.job.region !== undefined) {
                this.isTownshipDropdownOpen = !this.isTownshipDropdownOpen;
            }
            this.isCategoryDropdownOpen = false;
            this.isRegionDropdownOpen = false;
            this.isJobTypeDropdownOpen = false;
        },

        selectTownship(value) {
            this.job.town = value;
            this.isTownshipDropdownOpen = false;
        },

        toggleJobTypeDropdown() {
            this.isJobTypeDropdownOpen = !this.isJobTypeDropdownOpen;
            this.isCategoryDropdownOpen = false;
            this.isRegionDropdownOpen = false;
            this.isTownshipDropdownOpen = false;
        },

        selectJobType(value) {
            this.job.job_type = value;
            this.isJobTypeDropdownOpen = false;
        },

        handleOutsideClick(e) {
            if (!e.target.closest('.custom-select-wrapper')) {
                this.isCategoryDropdownOpen = false;
                this.isRegionDropdownOpen = false;
                this.isTownshipDropdownOpen = false;
                this.isJobTypeDropdownOpen = false;
            }
        },

        onChange(event) {
            var optionValue = event.target.value;
            this.job.job_type = optionValue;
        },

        onCompanyChange(event) {
            var optionValue = event.target.value;
            var optionText = event.target.options[event.target.options.selectedIndex].text;
            this.job.company_id = optionValue;
            this.job.company_name = optionText;
        },

        onCategoryChange(event) {
            var optionValue = event.target.value;
            var optionText = event.target.options[event.target.options.selectedIndex].text;
            this.job.category_id = optionValue;
            this.job.category_name = optionText;
        },

        onRegionChange(event) {
            var Value = event.target.value;
            this.job.region = Value;
            this.selectedTwspName = "";
            this.job.town = "";
            this.twspName = this.changeTwspName(Value);
        },

        changeTwspName(value, twspName) {
            twspName = this.twspNameJson[value];
            return twspName;
        },

        onChangeTwspName(event) {
            var Value = event.target.value;
            this.job.town = Value;
        },

        showJobUpdate() {
            axios.get("company/job/update/" + this.$route.params.id)
                .then(response => {
                    this.job = response.data;
                    if (this.job.short_desc === undefined || this.job.short_desc === null) {
                        this.$set(this.job, 'short_desc', '');
                    }
                    this.oldRegion = response.data.region;
                    this.twspName = this.changeTwspName(this.job.region);
                })
                .catch(error => {
                    console.log("Job Update API Error", error);
                });
        },

        getCategoryForJob() {
            axios.get("/job/category/list")
                .then(response => {
                    this.category = response.data;
                })
                .catch(error => {
                    console.log("Category List API Error", error);
                })
        },

        getCompanyForJob() {
            axios.get("/job/company/list")
                .then(response => {
                    this.company = response.data;
                })
                .catch(error => {
                    console.log("Company List API Error", error);
                })
        },

        handleSubmit() {
            this.submitted = true;
            if (this.$v.job.$invalid) {
                return;
            }
            this.updateJob();
        },

        updateJob() {
            this.isLoading = true;
            var request = {
                id: this.job.id,
                company_id: this.job.company_id,
                category_id: this.job.category_id,
                job_title: this.job.job_title,
                region: this.job.region,
                town: this.job.town,
                address: this.job.address,
                min_salary: this.job.min_salary,
                max_salary: this.job.max_salary,
                job_type: this.job.job_type,
                experience: this.job.experience,
                qualification: this.job.qualification,
                posted_date: this.job.posted_date,
                description: this.job.description,
                short_desc: this.job.short_desc,
                // latitude: this.job.latitude,
                // longitude: this.job.longitude,
                gender: this.job.gender,
                expired_date: this.job.expired_date
            };
            axios.post("company/job/updated", request)
                .then(() => {
                    this.$notification.success('အချက်အလက်များ ပြောင်းလဲခြင်းအောင်မြင်သည်။', {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                    this.isLoading = false;
                    this.$router.push({
                        path: "/company/dashboard/" + this.job.company_id
                    });
                })
                .catch(error => {
                    this.isLoading = false;
                    this.$notification.error("Job Post Edited Failed", {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                    console.log('Edited Job Error', error);
                });
        },
    },

    mounted() {
        this.getCategoryForJob();
        this.getCompanyForJob();
        this.showJobUpdate();
        window.addEventListener('click', this.handleOutsideClick);

        // $("#min_salary").on("keypress keyup blur", function (event) {
        //     $(this).val($(this).val().replace(/[^\d].+/, ""));
        //     if ((event.which < 48 || event.which > 57)) {
        //         event.preventDefault();
        //     }
        // });

        // $("#max_salary").on("keypress keyup blur", function (event) {
        //     $(this).val($(this).val().replace(/[^\d].+/, ""));
        //     if ((event.which < 48 || event.which > 57)) {
        //         event.preventDefault();
        //     }
        // });
    },

    beforeDestroy() {
        window.removeEventListener('click', this.handleOutsideClick);
    }
};
